"use client";

import React from "react";
import { Star, Quote, Instagram } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  text: "Ich hatte null Erfahrung mit Websites. Mit PAGEMAKER24 war meine Seite in zwei Stunden online. Meine Kunden finden mich jetzt direkt über Google.",
  author: "Sandra Meier",
  location: "Frauenfeld",
  rating: 5,
  image: "https://pagemaker24.ch/wp-content/uploads/2026/04/Blablue.png?v=kvk6knb5r3o"
}, {
  id: 2,
  text: "Die KI-Erstellung hat mir Tage an Arbeit erspart. Endlich eine Website, die professionell aussieht und meine Kunden überzeugt.",
  author: "Markus Weber",
  location: "Aarau",
  rating: 5,
  image: "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/uyq.jpg?v=vzk2rx3507f"
}, {
  id: 3,
  text: "Wir betreuen über 15 KMU-Kunden über PAGEMAKER24. Ein Dashboard, alles im Griff. Das spart uns enorm viel Zeit.",
  author: "Sarah Steiner",
  location: "Winterthur",
  rating: 5,
  highlight: true
}, {
  id: 4,
  text: "Einfach, schnell und intuitiv. Genau das, was wir für unseren Handwerksbetrieb gesucht haben. Die Ladezeiten sind beeindruckend.",
  author: "Thomas Koch",
  location: "Solothurn",
  rating: 5,
  image: "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/13123.jpg?v=h045krwwoyd"
}, {
  id: 5,
  text: "Der Support ist erstklassig. Man merkt sofort, dass hier die Bedürfnisse von Schweizer KMU im Fokus stehen. Sehr empfehlenswert!",
  author: "Beat Müller",
  location: "Thun",
  rating: 5,
  image: "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/uuu.jpg?v=4gzm9tu3w7p"
}, {
  id: 6,
  text: "Als Coiffeuse hatte ich keine Zeit, mich um eine Website zu kümmern. PAGEMAKER24 hat das für mich übernommen – und jetzt kommen neue Kundinnen über Google.",
  author: "Leyla Ahmeti",
  location: "St. Gallen",
  rating: 5,
  image: "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/uuhuh.jpg?v=ifbzkfnhqw"
}, {
  id: 7,
  text: "Ich war skeptisch, ob KI wirklich eine gute Website bauen kann. Das Ergebnis hat mich überzeugt – sogar mein Webdesigner-Kollege war beeindruckt.",
  author: "Daniel Brunner",
  location: "Biel",
  rating: 5
}, {
  id: 8,
  text: "Für unser Café war eine eigene Website immer zu teuer. Mit PAGEMAKER24 zahlen wir einen Bruchteil und haben trotzdem eine top Seite.",
  author: "Nina Frei",
  location: "Rapperswil",
  rating: 5,
  image: "https://pagemaker24.ch/wp-content/uploads/2026/04/freepik__minimal-scene-of-a-woman-taking-an-order-at-a-bare__5763-1.png?v=2oakh8er4jj"
}];
export default function CustomerMoments() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="28237" id="stimmen-unserer-nutzer" className="bg-background py-20 relative overflow-hidden text-foreground">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-10 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-80 h-80 bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="font-medium tracking-widest uppercase text-sm mb-3 block !text-[hsl(16,88%,54%)]">
            Kundenstimmen
          </span>
          <h2 className="text-4xl md:text-5xl font-sans font-bold text-foreground mb-6">
            Das sagen unsere Kunden
          </h2>
          <p className="text-xl text-muted-foreground">
            KMU aus der ganzen Schweiz setzen auf PAGEMAKER24.
          </p>
        </div>

        <div ref={ref} className={`columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6 transition-opacity duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {testimonials.map((item, i) => <div key={item.id} data-index={i} className="break-inside-avoid">
              <Card className={`overflow-hidden border border-border shadow-lg hover:shadow-xl transition-shadow duration-300 rounded-xl ${item.highlight ? "bg-secondary" : "bg-card"}`}>
                <CardContent className="p-0">
                  {item.image && <img src={item.image} alt={`${item.author} aus ${item.location}`} className="w-full h-auto object-cover" />}
                  <div className="p-6">
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-1 text-primary">
                        {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className={`w-4 h-4 ${starIndex < item.rating ? "fill-current" : "text-muted stroke-current"}`} />)}
                      </div>
                      <div className="relative">
                        <Quote className="absolute -top-2 -left-2 w-8 h-8 text-primary/10 rotate-180" />
                        <p className="text-foreground relative z-10 italic leading-relaxed">
                          &ldquo;{item.text}&rdquo;
                        </p>
                      </div>
                      <div className="flex items-center justify-between mt-2">
                        <div>
                          <span className="font-bold text-sm text-foreground block">
                            — {item.author}
                          </span>
                          <span className="text-xs text-muted-foreground">
                            aus {item.location}
                          </span>
                        </div>
                        {item.highlight && <span className="text-xs bg-white border border-border px-2 py-1 rounded-full text-primary font-medium">
                            Top Bewertung
                          </span>}
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex flex-col items-center gap-4">
            <p className="text-muted-foreground text-lg">
              Folgen Sie uns für mehr Inspiration
            </p>
            <a href="https://www.instagram.com/pagemaker24.official/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-md px-8 py-2.5 text-sm font-medium text-white shadow-lg transition-all hover:shadow-xl hover:opacity-90" style={{
            backgroundColor: "hsl(16,88%,54%)"
          }}>
              <Instagram className="w-5 h-5" />
              Auf Instagram folgen
            </a>
          </div>
        </div>
      </div>
    </section>;
}